<template>
  <sa-page-layout :btnBackVisible="false" :btnNewVisible="true" :btnRefreshVisible="true" :linkedit="linkedit" :showModalLoading="showModalLoading" @refresh="onRefresh">
    <template slot="table-filter">
      <b-form @submit.prevent="onSubmit">
        <b-row>
          <b-col xs="12" sm="12" md="4" lg="4" xl="4">
            <label class="sa-label-data">Nome</label>
            <b-form-input v-model="progettiFiltro.nome" type="search" id="nome" placeholder="Nome"></b-form-input>
          </b-col>
          <b-col xs="12" sm="12" md="6" lg="6" xl="6">
            <label class="sa-label-data">Descrizione</label>
            <b-form-input v-model="progettiFiltro.descrizione" type="search" placeholder="Descrizione"></b-form-input>
          </b-col>
          <b-col xs="12" sm="12" md="2" lg="2" xl="2">
            <label class="sa-label-data">Stato</label>
            <b-form-select v-model="progettiFiltro.statoAttuale" :options="statiOptions" :value="''" value-field="stato" text-field="stato">
              <template #first>
                <b-form-select-option :value="null"> - Seleziona Stato - </b-form-select-option>
              </template>
            </b-form-select>
          </b-col>
        </b-row>
        <b-row style="margin-top: 5px">
          <b-col class="sa-padding-right text-right">
            <b-button type="submit" variant="info">{{ this.$i18n.t("global.lblFind") }}</b-button>
            <b-button type="reset" v-on:click="onReset" variant="danger">{{ this.$i18n.t("patients.lblResetFilter") }}</b-button>
          </b-col>
        </b-row>
      </b-form>
    </template>
    <template slot="table-body">
      <gestione-attivita-progetti-list-component ref="cmpGestioneAttivitaProgettiListComponent" @beforeLoadData="onBeforeLoadDataGestioneAttivitaProgettiListComponent" @afterLoadData="onAfterLoadDataGestioneAttivitaProgettiListComponent"></gestione-attivita-progetti-list-component>
    </template>
  </sa-page-layout>
</template>

<script>
import SaPageLayout from "../../../template/sa/components/layout/contents/SaPageLayout.vue";
import GestioneAttivitaProgettiListComponent from "../components/GestioneAttivitaProgettiListComponent.vue";
import GestioneAttivitaStatiMixin from "../mixinis/GestioneAttivitaStatiMixin";
export default {
  mixins: [GestioneAttivitaStatiMixin],
  components: { SaPageLayout, GestioneAttivitaProgettiListComponent },
  data() {
    return {
      showModalLoading: false,
      linkedit: "progetti",
      progettiFiltro: { nome: null, descrizione: null, statoAttuale: null, tipo: "PROGETTO" },
      statiOptions: [],
    };
  },
  mounted() {
    let me = this;
    me.$refs.cmpGestioneAttivitaProgettiListComponent.init(me.progettiFiltro);
    me.loadStati();
  },
  methods: {
    onBeforeLoadDataGestioneAttivitaProgettiListComponent() {
      let me = this;
      me.showModalLoading = true;
    },
    onAfterLoadDataGestioneAttivitaProgettiListComponent() {
      let me = this;
      me.showModalLoading = false;
    },
    onRefresh() {
      let me = this;
      me.$refs.cmpGestioneAttivitaProgettiListComponent.init(me.progettiFiltro);
    },
    onSubmit() {
      let me = this;
      me.$refs.cmpGestioneAttivitaProgettiListComponent.init(me.progettiFiltro);
    },
    onReset() {
      let me = this;
      me.progettiFiltro = { nome: null, tipoAttivita: null, descrizionePriorita: null, statoAttuale: null, tipo: "PROGETTO" };
      me.$refs.cmpGestioneAttivitaAttivitaListComponent.init(me.progettiFiltro);
    },
  },
};
</script>

<style></style>
